/** @jsxImportSource @emotion/react */
import { CSSObject, css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { TFunction } from "i18next";

import { useMediaQueries } from "../../../../../../../shared";
import CloseButton from "../../../../../../../shared/components/buttons/CloseButton";
import { useStyles } from "../../../../../styles";

interface FindDeviceTopControlsProps {
  t: TFunction<"translation", undefined>;
  close: () => void;
}

const FindDeviceTopControls = ({ t, close }: FindDeviceTopControlsProps) => {
  const { fromMd } = useMediaQueries();

  const { navbarItemTopControls, navbarItemDialogTitle } = useStyles();

  return (
    <div
      data-testid="find-device-top-controls"
      css={css([
        navbarItemTopControls,
        {
          padding: "16px 16px 12px 0"
        }
      ])}
    >
      <Typography variant="h6" sx={navbarItemDialogTitle as CSSObject}>
        {t("Search##find device##find device")}
      </Typography>

      {fromMd && (
        <CloseButton onClose={close} customStyle={{ right: "-10px" }} />
      )}
    </div>
  );
};

export default FindDeviceTopControls;
